export default __webpack_public_path__ + "static/media/rack5.338b9550.webp";